var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.33333"},[React.createElement("path",{"d":"m2.5 8h11","key":0}),React.createElement("path",{"d":"m8 2.5v11","key":1})]));
}

Plus.defaultProps = {"fill":"none","height":"16","viewBox":"0 0 16 16","width":"16"};

module.exports = Plus;

Plus.default = Plus;
